import { useTranslation } from 'react-i18next'
import { formatNumberWithCommas } from '../../../../_common/functions'
import Icon from '../../../../components/icons'
import Text from '../../../../elements/Typo/Text'

interface Props {
    group?: any
    groupTotal: number
    grp_sum?: any
    ready?: boolean
}

const Groups: React.FC<Props> = ({ group = false, groupTotal, grp_sum, ready = true }) => {
    const { t } = useTranslation()
    return (
        <div className={`flex gap-2 border rounded-[0.5rem] p-2 ${group?.is_control ? 'bg-[#F5E00326] border-primary' : 'bg-[#F5F5F5] border-[#464E5F1A]'}`}>
            <Icon name="barChart" size={2} className="flex-shrink-0" />
            <div className="flex-grow">
                <div className="flex items-center gap-2 mb-1">
                    <Text size="md" className="font-semibold" title={group.name}>
                        {group?.name?.length > 25 ? `${group.name.slice(0, 25)}...` : group.name}
                    </Text>
                    {group?.is_control && (
                        <Text size="sm" className="px-1 bg-primary rounded-[0.717rem] !leading-4">
                            {t('Control Group')}
                        </Text>
                    )}
                </div>
                <div className="flex items-center mb-2">
                    <Text size="xs" className="font-semibold">
                        <span className="text-[#666666] !font-medium">{t('Action Taken:')}</span>

                        <span title={group.action}>{group.action?.length > 25 ? `${group.action.slice(0, 25)}...` : group.action}</span>
                    </Text>

                    <div className="border-r border-[#74788D] h-[0.8rem] mx-1"></div>
                    <Text size="xs" className="font-semibold whitespace-nowrap">
                        <span className="text-[#666666] !font-medium">{t('Distribution % :')}</span> {(group?.group_allocation_percentage ?? 0).toFixed(2)}%{/* 5% */}
                    </Text>
                </div>

                <div className="w-full rounded-sm bg-[#B8B8B8] overflow-hidden">
                    <div
                        className="bg-primary rounded-sm h-[0.3rem]"
                        style={{
                            width: `${group.group_size / (groupTotal / 100)}%`,
                        }}
                    ></div>
                </div>
            </div>
            <div className="flex-shrink-0 text-center">
                <Text size="xs" className="text-[#919191]">
                    {t('Group Size')}
                </Text>
                <Text className="text-black font-semibold">{ready ? formatNumberWithCommas(group.group_size) : '-'}</Text>
                <Text className="!text-[#666666] font-semibold">
                    {t('out of')} <span className="!text-black">{ready ? formatNumberWithCommas(grp_sum || 0) : '-'}</span>
                </Text>
            </div>
        </div>
    )
}

export default Groups
